export const ACCOUNT_LABELS = 'account';

// account paymentGC
export const lblPaymentAddNewAddCta = 'lbl_payment_addNewAddCta';
export const lblPaymentCardNumber = 'lbl_payment_cardNumber';
export const lblPaymentExpMonth = 'lbl_payment_expMonth';
export const lblPaymentExpYear = 'lbl_payment_expYear';
export const lblPaymentBillingAddress = 'lbl_payment_billingAddress';
export const lblPaymentCcAdressSelect = 'lbl_payment_ccAdressSelect';
export const lblPaymentEditCCHeading = 'lbl_payment_editCCHeading';
export const lblPaymentAddCCHeading = 'lbl_payment_addCCHeading';

// account common
export const lblCommonAddCTA = 'lbl_common_addCTA';

// account addressBook
export const ACC_LBL_EDIT_ADDRESS = 'ACC_LBL_EDIT_ADDRESS';
export const ACC_LBL_VERIFY_YOUR_ADDRESS_HEADING_ADD = 'ACC_LBL_VERIFY_YOUR_ADDRESS_HEADING_ADD';

const AddEditCreditCardLabels = {
  account: {
    paymentGC: {
      [lblPaymentAddNewAddCta]: 'Add A New Address',
      [lblPaymentCardNumber]: 'Card Number',
      [lblPaymentExpMonth]: 'Exp. Month',
      [lblPaymentExpYear]: 'Exp. Year',
      [lblPaymentBillingAddress]: 'Billing Address',
      [lblPaymentCcAdressSelect]: 'Select from address book',
      [lblPaymentEditCCHeading]: 'EDIT CREDIT OR DEBIT CARD',
      [lblPaymentAddCCHeading]: 'ADD CREDIT OR DEBIT CARD',
    },
    common: {
      [lblCommonAddCTA]: 'ADD NEW CARD',
    },
    addressBook: {
      [ACC_LBL_EDIT_ADDRESS]: 'EDIT ADDRESS',
      [ACC_LBL_VERIFY_YOUR_ADDRESS_HEADING_ADD]: 'Add Address',
    },
  },
};
export default AddEditCreditCardLabels;
